import { useMemo } from 'react'

import { parse } from 'tldts'

import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

import { getLogoSrc } from 'Customer/index'

export const useMerchantLogoUrl = (): string | undefined => {
  const merchantSettings = useQuery(
    dashboard20240730Client.getMerchantForSequenceAccount
  )

  return useMemo(() => {
    if (!merchantSettings.data) return undefined

    const domainToUse =
      merchantSettings.data.appUrl ?? merchantSettings.data.email

    const domain = parse(domainToUse).domain

    if (!domain) return undefined

    return getLogoSrc({ domain })
  }, [merchantSettings.data])
}
